import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/_createMedOrder.scss';
import {
    useCreateMedOrderMutation,
    useGetPatientDetailsQuery,
} from '../../features/patient/patientService';
import PatientInformationHeader from '../../components/Patient/PatientInformationHeader';
import OrderMedicationForm from '../../components/Orders/OrderMedicationForm';
import PageTitle from '../../components/PageTitle';
import ConfirmationModal from '../../components/Orders/ConfirmationModal';
import { useState } from 'react';

const CreateMedOrder = () => {
    const { id: patientId = '' } = useParams();
    const navigate = useNavigate();
    const [createMedOrder, { isLoading: isCreatingMedOrder }] =
        useCreateMedOrderMutation();

    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isFailModalOpen, setIsFailModalOpen] = useState(false);

    const onSubmit = async (data: any) => {
        var res: any = await createMedOrder({ ...data });

        if (res.data) {
            setIsSuccessModalOpen(true);
        }
        else {
            setIsFailModalOpen(true);
        }
    };

    const { data: patientDetails } = useGetPatientDetailsQuery({
        id: patientId,
    });

    return (
        <div>
            <PageTitle
                title="Add New Medication"
                onClick={() => navigate(-1)}
            />

            <div className="mx-5">
                {patientDetails && (
                    <PatientInformationHeader
                        patient={patientDetails}
                        navigate={() => navigate(-2)}
                    />
                )}
                <OrderMedicationForm
                    toastMessage="Medication successfully added to Queue"
                    cancelButton={
                        <Button
                            onClick={() =>
                                navigate(
                                    `/patient/${patientId}/add-new-medication`,
                                )
                            }
                            className="me-4"
                            style={{
                                width: 120,
                                color: 'var(--hcrx-light-blue)',
                                borderColor: 'var(--hcrx-light-blue)',
                            }}
                            shape="round"
                        >
                            Cancel
                        </Button>
                    }
                    onSubmit={onSubmit}
                    isSubmitting={isCreatingMedOrder}
                    submitLabel="Add to Queue"
                />
            </div>

            <ConfirmationModal
                isOpen={isSuccessModalOpen}
                onClose={() => setIsSuccessModalOpen(false)}
                title="Successful!"
                message="The medication(s) were successfully added to the Medication Queue."
                primaryButtonText="View Medication Queue"
                secondaryButtonText="Add New Medication"
                onPrimaryButtonLinkToClick={()=> navigate(`/patient/${patientId}/add-new-medication`)}
                onSecondaryButtonLinkClick={()=> {
                    navigate(0)
                }}
            />

            <ConfirmationModal
                isOpen={isFailModalOpen}
                isSuccess={false}
                onClose={() => setIsFailModalOpen(false)}
                title="Failed"
                message="The medication(s) was not successfully added to the Medication Queue."
                primaryButtonText="Try Again"
                secondaryButtonText="View Medication Queue"
                onPrimaryButtonLinkToClick={()=> navigate(0)}
                onSecondaryButtonLinkClick={()=> {
                    navigate(-1)
                }}
            />
        </div>
    );
};

export default CreateMedOrder;
